import React from "react";
import Common from "./../Common";
import Cookies from "js-cookie";
import Header from "../Header";
import Loading from "../components/UI/Loading";
class SsoLogin extends Common {
  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    let user_id = this.props.match.params.user_id;
    const redirectUrl = new URLSearchParams(this.props.location.search).get(
      "redirect"
    );
    if (user_id) {
      var posteditData = {};
      posteditData["user_id"] = user_id;
      fetch(this.state.apiUrl + "SsoLogin?user_id=" + user_id)
        .then((response) => response.json())
        .then((result) => {
          var encdata = result.encdata;
          result = this.decrypt(encdata, 0);
          if (result.code == 200) {
            var check_is_admin = result.data.user_type == "ROLE_ADMIN" ? 1 : 0;
            const user_details = JSON.stringify(result?.data?.user);
            const userDetailsParse = JSON.parse(user_details);
            this.setToStorage("is_admin", check_is_admin);
            this.setToStorage("user_uuid", userDetailsParse[0].user_uuid);
            this.setToStorage("app_token", userDetailsParse[0].app_token);
            this.setToStorage("userLogin", "yes");
            this.setToStorage("encdata", encdata);
            this.setToStorage("user_details", user_details);
            // Cookies.set("token", result.token, {
            //   path: "/",
            //   domain: process.env.REACT_APP_COOKIE_DOMAIN,
            // });
            sessionStorage.setItem("userLogin", "yes");
            this.setState({ redirect: true });
            if (redirectUrl) {
              window.location.href =
                "//" + process.env.REACT_APP_LOCAL_URL + redirectUrl;
            } else {
              window.location.href = "/tattle/support-ticket/list";
            }
          } else {
            window.location.href = "/login";
          }
        });
    } else {
      window.location.href = "/login";
    }
  }
  render() {
    return (
      <div className="mainContent-panel-wrap">
        <Header
          brecum_name={{ name: "", link: "" }}
          brecum_page={"sso login"}
        />
        <div className="d-flex align-items-center justify-content-center">
          <Loading />
        </div>
      </div>
    );
  }
}
export default SsoLogin;
